import React from 'react';
import SrcSizesProps from './src-sizes.props';

const SrcSizes: React.FC<SrcSizesProps> = (
    {
        image,
        imageSizes,
        alt,
        title,
        lazyLoad,
        className,
        width,
        height
    }
) => {
    return (
        <img
            width={width}
            height={height}
            src={image}
            alt={alt}
            srcSet={(imageSizes && width) ? imageSizes.map(image => `${image.image} ${image.width}w`).join(', ') : undefined}
            sizes={(imageSizes && width) ? `(max-width: ${width}px) 100vw, ${width}px` : undefined}
            loading={lazyLoad ? 'lazy' : 'eager'}
            className={className}
            title={title}
        />
    );
};

export default SrcSizes;
